<div class="wrapper" [@fadeInOnEnter] [@fadeOutOnLeave]>
    <h2 class="box-title">
      <span>
        Information
      </span>
    </h2>
    <div class="text-content">
      Unfortunately, you have to pair your vehicle with a phone number that you entered on vehicle's mobile app . 
To pair a different phone number, you have go back to the vehicle's mobile app and enter the phone number to start the onboarding process again.
    </div> 
    <div class="button-box">
      <app-main-button
        (onClick)="onPopOverKeepPlan()"
        [buttonWidth]="'90%'"
        [border]="'1px solid gray'"
        [textColor]="'#FFFFFF'"
        [backgroundColor]="'gray'"
        [buttonText]="'Close'">
      </app-main-button>
    </div>
  </div>